import type {StorageManager} from 'common/contexts/storage-manager/types';
import {userCookieUtils} from 'common/report/util/user-identity-from-cookie';
import {UserLocalStorageHelper} from 'common/report/user-local-storage';
import {LocalStorageKey} from 'common/report/constants';

type PersistedMetricsBetaButtonState = {
  closedPreBeta: boolean;
  closedBeta: boolean;
  raisedHandPreBeta: boolean;
};

const DEFAULT_STATE: PersistedMetricsBetaButtonState = {
  closedPreBeta: false,
  closedBeta: false,
  raisedHandPreBeta: false,
};

export function getPersistedState(params: {
  localStorageManager: StorageManager;
  projectId: string;
}): PersistedMetricsBetaButtonState {
  const userLocalStorageHelper = new UserLocalStorageHelper<PersistedMetricsBetaButtonState>({
    context: params.localStorageManager,
    namespace: LocalStorageKey.MetricsBetaButton,
  });

  const userId = userCookieUtils.getUserIdentityFromCookie()?.id;

  if (!userId) {
    return DEFAULT_STATE;
  }

  // gets user or project persisted state
  // to prevent the banner from showing up for
  // users that dismissed it in a project
  const persistedState =
    userLocalStorageHelper.getItem({
      key: LocalStorageKey.MetricsBetaButton,
      userId,
    }) ??
    userLocalStorageHelper.getItem({
      key: params.projectId,
      userId,
    });

  if (!persistedState) {
    return DEFAULT_STATE;
  }
  return persistedState;
}

export function setPersistedState(params: {
  localStorageManager: StorageManager;
  updatedState: PersistedMetricsBetaButtonState;
}): Promise<boolean> | boolean {
  const userLocalStorageHelper = new UserLocalStorageHelper<PersistedMetricsBetaButtonState>({
    context: params.localStorageManager,
    namespace: LocalStorageKey.MetricsBetaButton,
  });

  const userId = userCookieUtils.getUserIdentityFromCookie()?.id;

  if (!userId) {
    return false;
  }

  return userLocalStorageHelper.setItem({
    key: LocalStorageKey.MetricsBetaButton,
    userId,
    value: params.updatedState,
  });
}
